import { Box, Button, Grid, Typography } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import useAPI from "../../../../../api/hooks/useAPI";
import useColors from "../../../../../api/hooks/useColors";
import { labelKeys } from "../../../../../api/queryKeys";
import CustomToolTip from "../../../../../components/CustomTooltip";
import SvgToIcon from "../../../../../icons/SvgToIcon";
import { useEntities } from "../../hooks/useEntities";
import { icons } from "../../icons/iconExport";
import LabelChipWithDropDown from "../LabelsDropDown/LabelChipWithDropDown";
import LabelsDropdown from "../LabelsDropDown/LabelsDropdown";

const LabelsListSection = ({ selectedEntity }) => {
  const { getAllLabels } = useAPI();
  const { useQueryForEntitiesByType } = useEntities();

  const labelsQuery = useQuery({
    queryKey: labelKeys.all,
    queryFn: getAllLabels,
    select: (data) => data.data,
  });

  const entitiesQuery = useQueryForEntitiesByType({
    type: selectedEntity?.entity_type,
    enabled: Boolean(selectedEntity?.entity_type),
  });

  const labelIdToNameMap =
    labelsQuery.data
      ?.filter((label) => !label.is_deleted)
      .reduce((acc, label) => {
        acc[label.label_id] = label.name;
        return acc;
      }, {}) || {};

  const entities = entitiesQuery.data || [];
  const cachedEntity = Array.isArray(entities)
    ? entities.find((e) => e.entity_id === selectedEntity?.entity_id)
    : null;
  const currentEntity = cachedEntity || selectedEntity;

  const entityLabels = currentEntity?.labels || [];
  const validLabelIds =
    entityLabels.filter((labelId) => labelIdToNameMap[labelId]) || [];

  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const colors = useColors();
  return (
    <Grid
      item
      xs={12}
      display={"flex"}
      flexDirection={"column"}
      gap={"12px"}
      mt={"8px"}
    >
      <Box
        display={"flex"}
        flexDirection={"row"}
        gap={"10px"}
        alignItems={"center"}
      >
        <Typography variant="subtitle1">Labels</Typography>
      </Box>
      <Box display={"flex"} flexDirection={"column"} gap={1}>
        <Box
          display={"flex"}
          flexDirection={"row"}
          gap={1}
          flexWrap={"wrap"}
          alignItems={"center"}
        >
          {validLabelIds.map((labelId) => (
            <LabelChipWithDropDown
              key={labelId}
              label={labelIdToNameMap[labelId]}
              entities={[currentEntity]}
            />
          ))}
          <CustomToolTip
            title={validLabelIds.length > 0 ? "Add a label" : null}
            placement="top"
          >
            <Button
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: "8px",
                padding: "2px 4px",
                borderRadius: "2px",
                textTransform: "none",
                whiteSpace: "nowrap",
                color: colors.text_secondary,
              }}
              onClick={(event) => setMenuAnchorEl(event.currentTarget)}
            >
              <SvgToIcon
                IconLogo={icons.AddIcon}
                style={{
                  width: "18px",
                  height: "18px",
                }}
              />
              {validLabelIds.length === 0 && (
                <Typography variant="caption">Add a label</Typography>
              )}
            </Button>
          </CustomToolTip>
        </Box>
        {menuAnchorEl && (
          <LabelsDropdown
            selectedEntities={[currentEntity]}
            menuAnchorEl={menuAnchorEl}
            setMenuAnchorEl={setMenuAnchorEl}
          />
        )}
      </Box>
    </Grid>
  );
};

export default LabelsListSection;
